import React from 'react'
import className from 'classnames'
import { getInitials, getUserBackgroundColor } from './helpers'
import IconPeople from '../../icon/IconPeople'
import './UserAvatar.less'
import { getTextClassForColor } from '../../../../../../shared/colorUtils'

const renderInitials = (user: { display_name: string | null | undefined }) => {
  const initials = getInitials(user)
  const backgroundColor = getUserBackgroundColor(user)
  const textClass = getTextClassForColor(backgroundColor)
  return (
    <span
      className={className('UserAvatar__initials', textClass)}
      style={{ backgroundColor }}
    >
      {initials}
    </span>
  )
}

const UserAvatar = ({
  user,
  size = 'normal'
}: {
  user: {
    display_name: string | null | undefined
    image_url: string | null | undefined
  }
  size?: 'small' | 'normal'
}) => {
  const imageUrl = user.image_url
  return (
    <div className={className('UserAvatar', size)}>
      {imageUrl && (
        <div
          className="UserAvatar__image"
          style={{ backgroundImage: `url(${imageUrl})` }} // we use a div instead of an image because we need background image positioning
        />
      )}
      {!imageUrl && renderInitials(user)}
    </div>
  )
}

export default UserAvatar

export const PlaceholderAvatar = ({ text = '' }: { text: string }) => {
  return <div className="UserAvatar UserAvatar--placeholder">{text}</div>
}

export const GroupAvatar = () => {
  return (
    <div className="UserAvatar UserAvatar--placeholder">
      <IconPeople />
    </div>
  )
}
